import React from 'react';

interface StepCircleProps {
  stepNumber: number;
  status: 'completed' | 'pending';
  size?: number;
  onClick?: () => void;
}

export const StepCircle: React.FC<StepCircleProps> = ({ stepNumber, status, size = 56, onClick }) => {
  const getCircleStyles = () => {
    if (status === 'completed') {
      return {
        backgroundColor: 'var(--bs-success)',
        color: 'white',
        border: '2px solid var(--bs-success)',
      };
    }
    return {
      backgroundColor: 'white',
      color: 'var(--bs-secondary)',
      border: '2px solid var(--bs-border-color)',
    };
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle fw-bold"
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: size > 50 ? '1rem' : '1.3rem',
        cursor: onClick ? 'pointer' : 'default',
        ...getCircleStyles(),
      }}
    >
      {stepNumber}
    </div>
  );
};
